import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, } from 'react';
import { roleHierarchy, } from '../entities/profile-entities';
import { usePlatform } from './platform-provider';
const FeatureFlagContext = createContext({});
FeatureFlagContext.displayName = 'FeatureFlagContext';
export const FeatureFlagProvider = ({ children, flags, adminRole, userRole, }) => {
    const { isDev } = usePlatform();
    const isAllowed = useCallback((requiredRole, enabled) => {
        const isAdmin = adminRole === 'SuperAdmin' || isDev;
        if (!enabled)
            return isAdmin;
        const allowedRoles = roleHierarchy[userRole];
        return allowedRoles.includes(requiredRole) || isAdmin;
    }, [isDev, adminRole, userRole]);
    const enabledFlags = useMemo(() => {
        const result = {};
        Object.entries(flags).forEach(([key, { minimalAllowedRole, enabled }]) => {
            result[key] = isAllowed(minimalAllowedRole, enabled) && enabled;
        });
        return result;
    }, [flags, isAllowed]);
    return (_jsx(FeatureFlagContext.Provider, { value: enabledFlags, children: children }));
};
export const useFeatureFlags = () => useContext(FeatureFlagContext);
